import React, { useCallback, useEffect, useState } from "react";
import RationalistImg from "../../assets/Images/RationalistImg.png";
import PerformerImg from "../../assets/Images/PerformerImg.png";
import HarmonizerImg from "../../assets/Images/HarmonizerImg.png";
import OptimizerImg from "../../assets/Images/OptimizerImg.png";
import SaleRepClassificationCard from "../../components/SalesRepClassificationCard/salesRepClassifictationCard";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/Reducer";
import { cardContentArr } from "../../utils/content";
import { Button } from "reactstrap";
import {
  SAVE_PROFILE_DETAILS,
  UPDATE_PROFILE_DETAILS,
} from "../../redux/Action/actionTypes";

const Profile: React.FC = () => {
  const [cardSelected, setCardSelected] = useState<string>("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileData = useSelector(
    (state: RootState) => state.profile.profileData
  );

  useEffect(() => {
    setCardSelected(profileData.type);
  }, [profileData]);

  const classificationTypeSave = (typeName: string) => {
    if (typeName === cardSelected) {
      setCardSelected("");
    } else {
      setCardSelected(typeName);
    }
  };

  const saveHandler = useCallback(() => {
    dispatch({
      type: profileData.isLoggedInFirstTime
        ? SAVE_PROFILE_DETAILS
        : UPDATE_PROFILE_DETAILS,
      payload: { UserType: cardSelected },
      meta: {
        onSuccess: () => {
          navigate("/"); // Navigate to the overview page after successful save
        },
      },
    });
  }, [cardSelected, dispatch, profileData.isLoggedInFirstTime, navigate]);

  return (
    <div className="profileContainer">
      <div className="salesRepClassificationContainer">
        <p className="salesRepContent">
          Please Select <u>your own</u> negotiating strategy type.
        </p>
        <div className="row minHeight">
          <div className="hyperlink col-12">
            <a href="/negotiation_strategy_types_details.pdf" target="_blank">
              Read more about the differences between the negotiation
              strategies!
            </a>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3  repCard">
            <SaleRepClassificationCard
              classList={"card1"}
              cardImg={RationalistImg}
              cardHeading="Rationalist"
              subHeading="“The truth of the story lies in the details”"
              cardContent={cardContentArr[0]}
              cardSelected={cardSelected}
              cardHandler={() => classificationTypeSave("Rationalist")}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3  repCard">
            <SaleRepClassificationCard
              classList={"card2"}
              cardImg={PerformerImg}
              cardHeading="Performer"
              subHeading="“Don’t let anything stop you from reaching your goals”"
              cardContent={cardContentArr[1]}
              cardSelected={cardSelected}
              cardHandler={() => classificationTypeSave("Performer")}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3  repCard">
            <SaleRepClassificationCard
              classList={"card3"}
              cardImg={HarmonizerImg}
              cardHeading="Harmonizer"
              subHeading="“Keep calm to achieve your goals”"
              cardContent={cardContentArr[2]}
              cardSelected={cardSelected}
              cardHandler={() => classificationTypeSave("Harmonizer")}
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-3  repCard">
            <SaleRepClassificationCard
              classList={"card4"}
              cardImg={OptimizerImg}
              cardHeading="Optimizer"
              subHeading="“Minimal efforts to achieve given goals”"
              cardContent={cardContentArr[3]}
              cardSelected={cardSelected}
              cardHandler={() => classificationTypeSave("Optimizer")}
            />
          </div>
        </div>
        <div className="row buttonContainer">
          <Button className="saveButton" onClick={saveHandler}>
            Save and return to overview
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
